import { observer } from 'mobx-react-lite';
import { AppLogo } from '@pro-sto/ui';
import AppNavigation from '../AppNavigation/AppNavigation';
import AppHeaderMenu from '../AppHeaderMenu/AppHeaderMenu';
import type { TabId } from '../AppNavigation/AppNavigation';
import './AppHeader.css';

interface AppHeaderProps {
  activeTab?: TabId;
}

const AppHeader = observer(({ activeTab }: AppHeaderProps) => {
  return (
    <header className="app-header" data-testid="header">
      <div className="app-header__inner">
        <AppLogo />
        <AppNavigation activeTab={activeTab} />
        <div className="app-header__actions" data-testid="user-info">
          <AppHeaderMenu />
        </div>
      </div>
    </header>
  );
});

AppHeader.displayName = 'AppHeader';

export default AppHeader;
